import { create } from "zustand";

import { createSelectors } from "@khol/utils/create-selectors/create-selectors";
import { Toast } from "@khol/ui/Toast";

const TOAST_TIMEOUT = 7000; // 1000 = 1 second
export const useToastStoreBase = create<ToastState>()((set, get) => ({
  lastId: 0,
  toasts: [],
  add: (toast) => {
    get().addMulti([toast]);
  },
  addMulti: (toasts) => {
    if (toasts.length === 0) return;
    let id = get().lastId;
    const newToasts = toasts.map((t) => {
      id++;
      const timeoutId = setTimeout(() => get().remove(id), TOAST_TIMEOUT);
      return { ...t, id: id, timeoutId };
    });
    set((state) => ({
      toasts: [...state.toasts, ...newToasts],
      lastId: id,
    }));
  },
  remove: (id) => {
    const timeoutId = get().toasts.find((t) => t.id === id)?.timeoutId;
    clearTimeout(timeoutId);
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));



interface ToastState {
  lastId: number;
  toasts: Toast[];
  add: (toast: Omit<Toast, "id" | "timeoutId">) => void;
  addMulti: (toasts: Array<Omit<Toast, "id" | "timeoutId">>) => void;
  remove: (id: number) => void;
}
const useToastStore = createSelectors(useToastStoreBase);
export default useToastStore;
